import * as m from '~/paraglide/messages'
import { createFieldValidators } from '~/shared/lib/form-utils'
import { updateBasicInfoSchema } from '~/shared/types'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/shared/ui/card'
import { FormInput, FormTextarea } from '~/shared/ui/form'

interface BasicInfoSectionProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form API is dynamically typed
  form: any
}

export function BasicInfoSection({ form }: BasicInfoSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{m.basicInformation()}</CardTitle>
        <CardDescription>{m.updateYourBusinessNameAndDescription()}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <form.Field
          name="name"
          validators={createFieldValidators(updateBasicInfoSchema.shape.name)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => <FormInput field={field} label={m.businessName()} />}
        </form.Field>

        <form.Field
          name="description"
          validators={createFieldValidators(updateBasicInfoSchema.shape.description)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <FormTextarea
              field={field}
              label={m.description()}
              placeholder={m.detailedDescriptionOfYourBusiness()}
            />
          )}
        </form.Field>
      </CardContent>
    </Card>
  )
}
